// import { Link } from "react-router-dom";
export default function Future() {
  return (
    <>
      <div id="future" className="container-fluid">
        <h2 className="head_pt future_heading">Future plans</h2>

        <div className="row future_row">
          <div className="col-sm-5 picture picture1">
            <img
              src={"images/06_new.gif"}
              className="team_img future-img floating"
              alt="teamm"
            />
          </div>
          <div className="col-sm-7 future_info" style={{ margin: "auto" }}>
            <h5 className="">Metaverse usability</h5>
            <b></b>
            <p className="banner-para future_para">
              As already mentioned, every<b> Little Billionaire</b> will have
              the opportunity to see their character or characters again in
              various metaverses. Whether as a 3D avatar in games, movies, or
              other metaverse projects, it will maintain an ongoing connection
              to the metaverse for use by holders in the future of the
              <b> little billionaires</b>.
            </p>

            <h5 className="wives">Little Billionaire Wives</h5>
            <b></b>
            <p className="banner-para future_para">
              What would a true billionaire or the woman at his side be? In Q4
              2022, the Billionaire family will be expanded. <br />
              Our billionaires get their wives who will accompany them on the
              way. For the community, this means a host of new utilities, new
              ways to stake or be rewarded, and a variety of limited Holder
              Access Only passes. <br />
              The <b>Little Billionaires Wives</b> launch will be announced on
              social media. Keep your eyes peeled for Sneak Peaks.
            </p>
            <div></div>
          </div>
        </div>
      </div>
    </>
  );
}
